import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import GoogleTagManager from "./components/GoogleTagManager/GoogleTagManager";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <>
    <GoogleTagManager />
    <App />
  </>

  // </React.StrictMode>
);
